module.exports = __webpack_public_path__ + "static/media/homePage.9a458de7.jpg";